import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Assesment } from './assesment.class';
import { AssesmentQuestionType } from './assesment-question-type.enum';
import { AssesmentQuestionOption } from './assesment-question-option.class';

export class AssesmentQuestion extends BaseEntity {
	assesmentId: string;

	@Type(() => Assesment)
	assesment: Assesment;

	questionType: AssesmentQuestionType;
	questionText: string;
	translations: Record<string, string>;

	@Type(() => AssesmentQuestionOption)
	options: AssesmentQuestionOption[];
}
